import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const login = r => require.ensure([], () => r(require('./page/login.vue')), 'login')//登录
const stockin = r => require.ensure([], () => r(require('./page/stockin.vue')), 'stockin')//入货界面
const orders = r => require.ensure([], () => r(require('./page/orders.vue')), 'orders')//订单界面
const wo = r => require.ensure([], () => r(require('./page/wo.vue')), 'wo') //工单管理
const delivery = r => require.ensure([], () => r(require('./page/delivery.vue')), 'delivery')//出货管理
const warehouse = r => require.ensure([], () => r(require('./page/warehouse.vue')), 'warehouse') //仓库管理
const report = r => require.ensure([], () => r(require('./page/report.vue')), 'report')//报表管理
const client = r => require.ensure([], () => r(require('./page/client.vue')), 'client')//客户管理
const supplier = r => require.ensure([], () => r(require('./page/supplier.vue')), 'supplier')//供应商
const user = r => require.ensure([], () => r(require('./page/user.vue')), 'user')//用户界面
const formula = r => require.ensure([], () => r(require('./page/formula.vue')), 'formula')//公式界面
const inventory = r => require.ensure([], () => r(require('./page/inventory.vue')), 'inventory')//成品仓库
const print = r => require.ensure([], () => r(require('./page/print.vue')), 'print')//条码打印
const countPrice = r => require.ensure([], () => r(require('./page/countPrice.vue')), 'countPrice')//计价单
const logPrice = r => require.ensure([], () => r(require('./page/logPrice.vue')), 'logPrice')//地区物流
const dict = r => require.ensure([], () => r(require('./page/dict.vue')), 'dict')//数据字典
const zb = r => require.ensure([], () => r(require('./page/zb.vue')), 'zb')//纸板
const eClient = r => require.ensure([], () => r(require('./page/eClient.vue')), 'eClient')//电商客户
const eOrder = r => require.ensure([], () => r(require('./page/eOrder.vue')), 'eOrder')//电商订单
const olWoPrint = r => require.ensure([], () => r(require('./page/olWoPrint.vue')), 'olWoPrint')//在线工单打印
const mljs = r => require.ensure([], () => r(require('./page/mljs.vue')), 'mljs')//毛利计算
const confirmDel = r => require.ensure([], () => r(require('./page/confirmDel.vue')), 'confirmDel')//确认出货
const purchase = r => require.ensure([], () => r(require('./page/purchase.vue')), 'purchase')//进货记录
const recvPayment = r => require.ensure([], () => r(require('./page/recvPayment.vue')), 'recvPayment')//收款管理
const summary = r => require.ensure([], () => r(require('./page/summary.vue')), 'summary')//数据汇总
const eReport = r => require.ensure([], () => r(require('./page/eReport.vue')), 'eReport')//线上统计

let routeObj = {login,stockin,orders,wo,delivery,warehouse,report,client,supplier,user,formula,inventory,countPrice,logPrice,dict,zb,eClient,
    eOrder,olWoPrint,mljs,confirmDel,purchase,recvPayment,summary,eReport};

const routes = [];

for (let name in routeObj ) {
    routes.push({path:`/${name}`,name,component:routeObj[name]});
}

routes.push({path:`/print/:numbers`,name:'print',component:print});

const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    console.log('**********change route**********');
    console.log(to);
    let toName = to.name;
    let toPath = to.path;
    if (toName == 'login') {//登录界面
        if (localStorage.token) {//已经登录的
            sessionStorage.hasBar = 1;
            sessionStorage.toPath = toPath;
            let role = JSON.parse(localStorage.user).role;
            let path = role == 1 ? '/orders' : '/countPrice';
            next({path});
        } else {
            sessionStorage.hasBar = 0;
            next();
        }
    }else{//非登录界面
        if (localStorage.token) {//已登录
            if(['print','olWoPrint'].includes(toName)){
                sessionStorage.hasBar = 0;
            }else  sessionStorage.hasBar = 1;
            sessionStorage.toPath = toPath;
            next();
        }else {
            sessionStorage.hasBar = 0;
            next({path: '/login'});
        }
    }
})

export default router;